import React, { useMemo, useState } from "react";

import { Button, Alert, Modal, Form } from "react-bootstrap";
import { GetAvailablity, bookAppointment } from "../APIs/api-routes.util";
import GetPoneBookings from "./GetPoneBookings";
import Header from "../Dashboard/Header";
import Loader from "../common/spinner";
import { isMobile } from "react-device-detect";
function AdminBooking() {
  const [errorMessage, setErrorMessage] = useState("");
  const [show, setShow] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [origin, setOrigin] = useState("");
  const [isEnabled, setIsEnabled] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  // const formData = new FormData();
  const currentDate = new Date();
  const todaty = currentDate.toISOString().split("T")[0];
  const [token_number, set_token_number] = useState(0);
  const [data, setData] = useState({
    phone: "",
    date: todaty,
    name: "",
    guardianName: "",
  });

  const handleCloseModal = () => {
    setShowModel(false);
  };

  const checkDate = () => {
    if (data.date) {
      setShowLoader(true);
      GetAvailablity(data.date).subscribe((res: any) => {
        const response = res.response;
        setShowLoader(false);
        if ("response" in res && response.isAvailable && response.isNotFull) {
          setShow(true);
          setOrigin("success");
          setIsEnabled(true);

          setErrorMessage("The day you selected is available");
        } else {
          setShow(true);
          setOrigin("danger");
          setErrorMessage("The day you selected is unavailable");
        }
      });
    } else {
      setShow(true);
      setOrigin("danger");
      setErrorMessage("Please select the date");
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    setShowLoader(true);
    e.preventDefault();
    if (data.date && data.guardianName && data.name && data.phone) {
      bookAppointment(formData).subscribe((res: any) => {
        setShowLoader(false);
        if (
          "response" in res &&
          res.response?.success === "New appointment booked successfully"
        ) {
          setErrorMessage(res.response?.success);
          setOrigin("info");
          setShow(true);
          set_token_number(res.response?.token_number);
        } else {
          setErrorMessage("Something went wrong");
          setOrigin("danger");
          setShow(true);
        }
      });
    } else {
      setShow(true);
      setOrigin("danger");
      setErrorMessage("Please provice the folowing Info");
    }
  };
  // React.useEffect(() => {
  //   formData.append("name", data.name);
  //   formData.append("date", data.date);
  //   formData.append("guardianName", data.guardianName);
  //   formData.append("phone", data.phone);

  // }, [data ,formData]);
  const formData = useMemo(() => {
    const newFormData = new FormData();
    newFormData.append("name", data.name);
    newFormData.append("date", data.date);
    newFormData.append("guardianName", data.guardianName);
    newFormData.append("phone", data.phone);
    return newFormData;
  }, [data]);

  const handelUpdate = (items: { name: string; guardianName: string }) => {
    setData({ ...data, name: items.name, guardianName: items.guardianName });
  };

  return (
    <>
      <Header />
      <Loader show={showLoader} />
      <div className="main-container">
        <div className="form-admin-container">
          <Form
            style={
              isMobile
                ? { width: "90%" }
                : {
                    width: "50%",
                    padding: "20px",
                    border: " 1px solid #dbe2eb",
                    borderRadius: "5px",
                    boxShadow: "box-shadow: 1px 1px 39px 3px #000000",
                  }
            }
            onSubmit={handleSubmit}
            className="form-admin-booking"
          >
            <Form.Group
              style={{
                width: "100%",
              }}
              className="mb-3"
            >
              <Form.Label>Date</Form.Label>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? "10px" : "0px"
              }}
            >
              <Form.Control
                type="date"
                placeholder="Check available day"
                aria-label="Check available day"
                aria-describedby="basic-addon2"
                value={data.date}
                style={{ width: isMobile ? "100%" : "auto" }}
                onChange={(e) => {
                  setData({
                    ...data,
                    date: e.target.value,
                  });
                }}
              />
              <Button
                onClick={checkDate}
                variant="outline-secondary"
                id="button-addon2"
                style={{ 
                  width: isMobile ? "100%" : "auto",
                  fontSize: isMobile ? "14px" : "16px"
                }}
              >
                Check
              </Button>
            </div>
            </Form.Group>
            <Form.Group
              style={{
                width: "100%",
              }}
              className="mb-3"
            >
              <Form.Label>Phone</Form.Label>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? "10px" : "0px"
              }}
            >
              <Form.Control
                type="text"
                placeholder="Check Booked Appointments on phone NO"
                aria-label="Check Booked Appointments on phone NO"
                aria-describedby="basic-addon2"
                style={{ width: isMobile ? "100%" : "auto" }}
                onChange={(e) => {
                  setData({
                    ...data,
                    phone: e.target.value,
                  });
                }}
              />
              <Button
                variant="outline-secondary"
                onClick={() => {
                  setShowModel(true);
                }}
                id="button-addon2"
                style={{ 
                  width: isMobile ? "100%" : "auto",
                  fontSize: isMobile ? "14px" : "16px"
                }}
              >
                Check
              </Button>
            </div>
            </Form.Group>
            {!isEnabled ? (
              <>
                <Form.Group
                  style={{
                    width: "100%",
                  }}
                  className="mb-3"
                >
                  <Form.Label>Full Name</Form.Label>

                  <Form.Control
                    disabled
                    type="text"
                    placeholder="Enter Name"
                    aria-label="Enter Name"
                    aria-describedby="basic-addon2"
                    onChange={(e) => {
                      setData({
                        ...data,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group
                  style={{
                    width: "100%",
                  }}
                  className="mb-3"
                >
                  <Form.Label>Guardian Name</Form.Label>

                  <Form.Control
                    disabled
                    type="text"
                    placeholder="Enter Guardian Name"
                    aria-label="Enter Guardian Name"
                    aria-describedby="basic-addon2"
                    onChange={(e) => {
                      setData({
                        ...data,
                        guardianName: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
              </>
            ) : (
              <>
                <Form.Group
                  style={{
                    width: "100%",
                  }}
                  className="mb-3"
                >
                  <Form.Label>Full Name</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Enter Name"
                    aria-label="Enter Name"
                    value={data?.name}
                    aria-describedby="basic-addon2"
                    onChange={(e) => {
                      setData({
                        ...data,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group
                  style={{
                    width: "100%",
                  }}
                  className="mb-3"
                >
                  <Form.Label>Guardian Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Guardian Name"
                    aria-label="Enter Guardian Name"
                    aria-describedby="basic-addon2"
                    value={data?.guardianName}
                    onChange={(e) => {
                      setData({
                        ...data,
                        guardianName: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
              </>
            )}

            <div
              style={
                isMobile
                  ? { width: "100%" }
                  : { width: "100%", justifyContent: "flex-end" }
              }
              className="submit-button"
            >
              <Button
                style={isMobile ? { width: "50%" } : { width: "170px" }}
                type="submit"
              >
                Book Appointment{" "}
              </Button>     
              
            </div>
            <br /> 
                  {token_number ? <div className="alert alert-success">Your Token Number is: {token_number}</div>: ""}

          </Form>

        </div>
       
        <div className="alert-div"  style={isMobile ? { width: "95%" } : {width:'600px'}}>
          <Alert
            show={show}
            onClose={() => setShow(false)}
            dismissible
            variant={origin}
          >
            {errorMessage}
          </Alert>
        </div>
        <Modal size="lg" show={showModel} onHide={handleCloseModal}>
          
            <Modal.Header><h6>Privious Appointments</h6></Modal.Header>
         
          <Modal.Body>
            <GetPoneBookings
              phone={data.phone}
              handelUpdate={handelUpdate}
              data={data}
              setShowModel={setShowModel}
              setShowLoader={setShowLoader}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowModel(false);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default AdminBooking;
